import { createModule } from '../utils/factories';
import { resources } from '@/services/resources';
import crud from '../components/crud';
import indexManager from '../components/indexManager';
import processingTracker from '../components/processingTracker';

export default createModule({
  path: 'classificationEntryStats',
  resourceProfile: resources.classificationEntriesStats,
  components: [crud, indexManager, processingTracker],
  setup({ components }) {
    return {
      module: {},
      public: {
        ...components.$crud.public,
        ...components.$indexManager.public,
        ...components.$processingTracker.public,
      },
    };
  },
});
